import { AxArtwork, AxButton } from "@dynata/axiom3";
import img404 from "@dynata/axiom3-images/png/general_404.png";
import React from "react";
import { useNavigate } from "react-router-dom";
import paths from "paths";

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <main className="center-div">
      <AxArtwork
        title="Page Not Found"
        image={img404}
        description="Sorry, we can't find the page you're looking for."
        target="_blank"
      />
      <AxButton onClick={() => navigate(`/${paths.authenticated.DASHBOARD}`)}>
        go back
      </AxButton>
    </main>
  );
};
